import { graphql } from "@/graphql/codegen"

graphql(`
  query GetSalesProductList($input: ProductListInput!) {
    product {
      list(input: $input) {
        ... on ProductListSuccess {
          products {
            productId
            publicId
            vendorDescription
            stockType
            company {
              companyId
              name
            }
          }
        }
        ... on ProductListFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
